import React, { useEffect, useState } from "react";
import {
  Card,
  Col,
  Nav,
  NavItem,
  NavLink,
  Row,
  TabContent,
  TabPane,
} from "reactstrap";
import { useTranslation } from "react-i18next";
import Overview from "./Detail/Overview/Index";
import UtilitiesList from "./Detail/Utilities";
import inquiryListApi from "api/inquiryListApi";

const InquiryListDetail = ({
  inquiryID,
  setLinkImage,
  setTitleInquiryDetail,
}: any) => {
  const [detail, setDetail] = useState<any>();
  async function getDetail() {
    const response: any = await inquiryListApi?.getInquiryDetail(inquiryID);
    if (response.code == 200) setDetail(response?.data);
  }

  useEffect(() => {
    getDetail();
  }, []);

  return (
    <React.Fragment>
      <Row>
        <Col lg={12}>
          <Overview
            inquiryId={inquiryID}
            data={detail}
            setLinkImage={setLinkImage}
            setTitleInquiryDetail={setTitleInquiryDetail}
            reloadData={getDetail}
          />

          <UtilitiesList
            inquiryID={inquiryID}
            detail={detail}
            data={detail?.inquiry_replies || []}
            reloadData={getDetail}
          />
        </Col>
      </Row>
    </React.Fragment>
  );
};

export default InquiryListDetail;
